import React, { useState } from 'react';
import Maps from './MapComponent';
import './Map.css'

const Map = () => {
  const [country, setCountry] = useState('QATAR');
  const [zoomLevel, setZoomLevel] = useState(13); // Default zoom level

  const locations = {
    QATAR: { latitude: 25.3548, longitude: 51.1839, address: 'Qatar' },
    UAE: { latitude: 23.4241, longitude: 53.8478, address: 'UAE' },
    BAHRAIN: { latitude: 26.0667, longitude: 50.5577, address: 'BAHRAIN' },
    MOHALI: { latitude: 30.7046, longitude: 76.7179, address: 'MOHALI' },
    CHENNAI: { latitude: 13.0843, longitude: 80.2705, address: 'CHENNAI' },
  };

  const handleCountryChange = (event) => {
    setCountry(event.target.value);
  };

  const handleZoomChange = (event) => {
    setZoomLevel(parseInt(event.target.value, 10));
  };

  return (
    <section className='map-sec'>
      <select onChange={handleCountryChange} value={country}>
        <option value="QATAR">QATAR</option>
        <option value="UAE">UAE</option>
        <option value="BAHRAIN">BAHRAIN</option>
        <option value="MOHALI">MOHALI</option>
        <option value="CHENNAI">CHENNAI</option>
      </select>

      {/* <input
        type="number"
        min="1"
        max="20"
        value={zoomLevel}
        onChange={handleZoomChange}
        style={{ margin: '10px' }}
      /> */}

      <Maps
        latitude={locations[country].latitude}
        longitude={locations[country].longitude}
        address={locations[country].address}
        zoomLevel={8}
      />
    </section>
  );
};

export default Map;
